// extracted by mini-css-extract-plugin
export default {"checkbox":"styles_checkbox__Vou2O","checkboxLg":"styles_checkboxLg__bx5Vv"};